import produce from 'immer';

// TYPES
import { Types, ExcluirMotivo } from './types';
import { ReducerAction } from '../../../../../types';

export const INITIAL_STATE: ExcluirMotivo = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ExcluirMotivo {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_MOTIVO: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EXCLUIR_MOTIVO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_MOTIVO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_MOTIVO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
